import {Component, Prop, Vue} from "vue-property-decorator";

export const icons = {
  user: require('~/assets/inline-svg/icon_user.svg?inline'),
  allUsers: require('~/assets/inline-svg/icon_all_users.svg?inline'),
  userAccount:require('~/assets/inline-svg/icon_user_account.svg?inline'),
  stats:require('~/assets/inline-svg/icon_stats.svg?inline'),
  multiSettings:require('~/assets/inline-svg/icon_multi_settings.svg?inline'),
  close: require("~/assets/inline-svg/icon_close.svg?inline"),
  check: require("~/assets/inline-svg/icon_check.svg?inline"),
  plus: require("~/assets/inline-svg/icon_plus.svg?inline"),
  infinity: require("~/assets/inline-svg/icon_infinity.svg?inline"),
  search: require("~/assets/inline-svg/icon_search.svg?inline"),
  notification: require("~/assets/inline-svg/icon_notification.svg?inline"),
  home: require("~/assets/inline-svg/icon_home.svg?inline"),
};


@Component
export class Icon extends Vue {

  @Prop({type:String, required:true}) icon: string;

  getIcon(){

    if( ! this.icon ) {
      console.error(`unknown icon ${this.icon}`);
      return "";
    }

    return this.icon;
  }

  render(){
    return <div class="icon" domPropsInnerHTML={this.getIcon()} />
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-4db27136/icon.tsx" });